<template>
  <div class="hight-light" >
    <div class="content">
      <div v-show="isBg"><strong>{{bgText}}</strong></div>
      <p>{{text}}</p>
      <div v-if="english">{{english}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HightLight",
    props:{
      text:{
        type:String
      },
      english: {
        type: String
      },
      isBg:{
        type:Boolean,
        default(){
          return false
        }
      },
      bgText:{
        type:String
      }
    }
  }
</script>

<style lang="less" scoped>
  .hight-light{
    width: 100%;
    padding: 0 0 0.16rem 0;
    display: flex;
    justify-content: center;
    margin-bottom: 0.2rem;
    background: linear-gradient(180deg, rgba(39, 129, 221, 0.50) 12.06%, rgba(39, 129, 221, 0.03) 84.44%);
    .content{
      position: relative;
      width: 100%;
      text-align: center;
      p{
        font-size: 0.5rem;
        margin: 0;
        position: absolute;
        top: 0.6rem;
        left: 25%;
        z-index: 999;
      }
      strong{
        font-weight: bold;
        color: #FFFFFF;
        font-size: 0.7rem;
      }
      div {
        margin-top: 0.2rem;
        font-size: 0.36rem;
      }
    }
  }

</style>
